import { css } from '@emotion/css';
import axios from "axios";
import { useEffect, useState } from 'react';

const Banner =  ({ loggedIn = false, menuOpen = false }: { loggedIn?: boolean, menuOpen?: boolean }) => {
    const [bannerData, setBannerData] = useState<any[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/banner`);
                setBannerData(res.data);
            } catch(error) {
                console.error("Failed to fetch the banner information");
            }
        }
        fetchData();
    }, []);

    const menuWidth = loggedIn ? (menuOpen ? 340 : 88) : 0;
    const bannerWidth = loggedIn ? `calc(100vw - ${menuWidth}px)` : '100vw';
    const marginLeft = loggedIn ? `${menuWidth}px` : '0';

  return (
    <div className={css`
      width: ${bannerWidth};
      margin-left: ${marginLeft};
      height: auto;
      text-align: center;
      display: block;
      transition: margin-left 0.4s, width 0.4s;
    `}>
        {(bannerData.length > 0) ? (
            bannerData.map((item, index) => (
                <div key={index} style={{backgroundColor: item.background_color, color: item.text_color, fontSize: '20px'}}>
                    {item.marquee_text}
                </div>
            ))
        ) : (
            null
        )}
    </div>
  );
};

export default Banner;